let express = 1000 * 60 * 60 * 48 //设置过期时间   1000*60(一分钟)    1000*60*60(一小时) 
export const mystorage = {
  set(key, data, time) {
    let obj = {
      data: data,
      ctime: (new Date()).getTime(), //时间戳，同Date.now()
      express: express
    }
    sessionStorage.setItem(key, JSON.stringify(obj))
  },
  get(key) {
    let obj = JSON.parse(sessionStorage.getItem(key))
    if (obj) {
      let getItem = (new Date()).getTime();
      if (getItem - obj.ctime >= express) { // 如果开始时间大于等于过期时长  清空token   否则自动续开始时间
        obj.data = ""
        return obj.data;
      } else {
        let objs = {
          data: obj.data,
          ctime: (new Date()).getTime(), //时间戳，同Date.now()
          express: express
        }
        sessionStorage.setItem(key, JSON.stringify(objs))
        // console.log(getItem - obj.ctime >= express, getItem, obj.ctime, express, getItem - obj.ctime)
        return obj.data;
      }
    }


  }
}



// WEBPACK FOOTER //
// ./src/utils/myStorage.js